import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { getCurrentBrowserFingerPrint } from '@rajesh896/broprint.js';

const useFingerprint = () => {
  const [fingerprint, setFingerprint] = useLocalStorage<string | null>(
    'fingerprint',
    null,
  );

  useEffect(() => {
    let isMounted = true;

    const generateFingerprint = async () => {
      let fingerprint: string;
      try {
        fingerprint = await Promise.race([
          getCurrentBrowserFingerPrint(),
          new Promise<never>((_, reject) =>
            setTimeout(
              () => reject(new Error('Fingerprint generation timed out')),
              1000,
            ),
          ),
        ]);
      } catch {
        return;
      }

      if (isMounted) {
        setFingerprint(fingerprint);
      }
    };

    generateFingerprint();

    return () => {
      isMounted = false;
    };
  }, [setFingerprint]);

  return fingerprint ?? null;
};

export default useFingerprint;
